export const getCookieDomain = `.${globalThis.location.hostname.split('.').slice(-2).join('.')}`;
